import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import AppContext from '../context/AppContext'
import { formatter, removeImageOverlay } from '../../helpers/Strings'
import { priceFormatter } from '../../helpers/Numbers'
import { TagManager } from '../../helpers/TagManager'

const CarCard = ({ car }) => {
	// console.log(car);
	const app = useContext(AppContext);
	const [favorite, setFavorite] = useState(false);

	const featuredImage = () => {
		if (!car.featuredImage) {
			return '';
		}

		return <img className='loading' onLoad={(e) => { e.currentTarget.classList.toggle('loading') }} src={removeImageOverlay(car.featuredImage)} alt={car.title + ' ' + car.shortDescription} />
	}

	// const getTags = () => {
	// 	const tagLabelMap = {
	// 		demo: { label: 'Demobil', className: 'demo' },
	// 		superdeal: { label: 'Superdeal', className: 'superdeal' },
	// 		volvoselekt: { label: 'Volvo Selekt', className: 'volvo-selekt' }
	// 	};

	// 	const normalizeDeal = (deal = '') =>
	// 		deal.toLowerCase().replace(/[^a-z0-9]/g, ''); // Volvo-Selekt, VolvoSelekt, volvo selekt -> volvoselekt

	// 	const tags = (car.activeDeals ?? [])
	// 		.map((deal) => tagLabelMap[normalizeDeal(deal)])
	// 		.filter(Boolean)
	// 		.map((tag) => ({
	// 			class: tag.className,
	// 			label: tag.label
	// 		}));

	// 	return (
	// 		<>
	// 			{tags.map((tag, i) => <span key={`tag_${i}`} className={`tag ${tag.class}`}>{tag.label}</span>)}
	// 		</>
	// 	);
	// };
	const hasVolvoSelektKeyword = (keywords = '') => {
		return /(^|\s)volvo[- ]?selekt(\s|$)/i.test(keywords);
	};

	const getBadges = () => {
		const badges = (car.customGroupDetails ?? [])
			.filter(group => group.show_badge)
			.map(group => ({
				class: 'badge',
				label: group.badge_content
			}));

		return (
			<>
				{badges.map((badge, i) => <span key={`badge_${i}`} className={`badge ${badge.class}`}>{badge.label}</span>)}
			</>
		)
	};

	const getTags = () => {
		const tagLabelMap = {
			'Demo': 'Demobil',
			// 'Outlet': 'Outlet',
			'Superdeal': 'Superdeal',
		};

		const tags = (car.activeDeals ?? [])
		.filter(deal => tagLabelMap[deal]) // Ensure the deal is recognized.
				.map(deal => ({
					class: deal.toLowerCase(), // Assuming class names are lowercase deal names
					label: tagLabelMap[deal]
				}));

		// TODO: This should be fixed properly later
		// if(car.hasCampaigns) {
		// 	tags.push({class:'kampanj',label: 'Kampanj'})
		// }
		if (car.manufacturer == 'Volvo' && hasVolvoSelektKeyword(car.keywords)) {
			tags.push({ class: "volvo-selekt", label: "Volvo Selekt" });
		}

		return (
			<>
				{tags.map((tag, i) => <span key={`tag_${i}`} className={`tag ${tag.class}`}>{tag.label}</span>)}
			</>
		)
	}

	const getIcon = () => {
		if (['Laddhybrid', 'Hybrid'].includes(car.engineBaseType)) {
			return <span role="img" aria-label="hybrid" className="eco icon-plugin"></span>
		} else if (['Mildhybrid', 'Elhybrid'].includes(car.engineBaseType)) {
			return <span role="img" aria-label="el" className="eco icon-leaf"></span>
		}
		return;
	}

	const currentPrice = ({ price, oldPrice, leasingPrice }) => {
		const hasDiscount = (oldPrice && oldPrice > price) ? true : false;

		const hasLeasing = (leasingPrice) ? true : false;

		return (
			<>
				<div className="price-details">
					<div className={hasDiscount ? 'price discount' : 'price'}>
						{hasDiscount && <span className="price old">{priceFormatter(oldPrice)}</span>}
						<span className='price current'>{priceFormatter(price, '\u00A0kr')}</span>
					</div>
					<span className="loan">
						{car.monthlyCost &&
							<>Lån fr. <strong>{priceFormatter(car.monthlyCost, '\u00A0kr/mån')}</strong></>
						}
					</span>
				</div>
				{hasLeasing && <div className="leasing">Privatleasing från <strong>{priceFormatter(leasingPrice, ' kr/mån')}</strong></div>}
			</>
		)

	}

	const generatePrettyURL = () => {
		const urlString = `${car.title} ${car.shortDescription}`.toLowerCase()

		return (
			formatter(car.manufacturer).url() + '/' +
			formatter(car.modelSeries).url() + '/' +
			urlString
				.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
				.replace(/\s+/g, '-') // collapse whitespace and replace by -
				.replace(/-+/g, '-') // collapse dashes
				.replace(/^[^a-z0-9]/, '')
				.replace(/[^a-z0-9]$/, '') +
			'--' +
			car.waykeId
		)
	}

	const LinkTo = (props) => {
		if (app.headless) {
			return <a href={'/' + app.path + props.to}>{props.children}</a>
		} else {
			return <Link to={props.to}>{props.children}</Link>
		}
	}

	const getMotortype = () => {
		if (car.engineBaseType == 'Förbränningsmotor') {
			return car.fuelType;
		} 
		return car.engineBaseType;
	}

	const toggleFavorite = useCallback((e) => {
		e.preventDefault();

		if (!window.user) {
			return false;
		}

		if (window.user.favoritesList.includes(car.waykeId)) {
			window.user.remove(car)
			setFavorite(false)

		} else {
			window.user.add(car)
			setFavorite(true)
			TagManager({ event: 'CarSavedConversion', data: car })
		}

	}, [car])

	useEffect(() => {

		let interval;
		const checkUser = () => {
			if (window.user === undefined) {
				return
			}
			setFavorite(window.user.favoritesList.includes(car.waykeId))
			clearInterval(interval)
		}
		interval = setInterval(checkUser, 50)

	}, [car]);

	return (
		<div className='car'>
			{/* {console.log(car)} */}
			<LinkTo to={'/' + generatePrettyURL()}>
				<div className='wrapper'>
					<span className="tags">
						{getBadges()}
						{getTags()}
					</span>
					{featuredImage()}
				</div>
				<div className='details'>
					<h4 className='title'>{car.title}</h4>
					{getIcon()}
					<h5 className='sub-title'>{car.shortDescription}</h5>
					<div className='keywords'>
						<span className="keyword">
							{
								(function () {
									const description = car.title + ' ' + car.shortDescription + ' ' + car.salesName;
									if (description.match(/Demo/gi)) {
										return 'Demo'
									} else if (car.mileage <= 20) {
										return 'Ny'
									} else {
										return 'Begagnad'
									}
								})()
							}
						</span>
						{ getMotortype() && <span className="keyword">{getMotortype()}</span> }
						{/* <span className="keyword">{car.fuelTypes}</span> */}
						{/* <span className="keyword">{car.fuelType}</span> */}
						<span className="keyword">{car.gearboxType}</span>
						<span className="keyword">{priceFormatter(car.mileage, ' mil')}</span>
						<span className="keyword">{car.modelYear}</span>
					</div>
					{currentPrice(car)}
				</div>
				<div className="position">
					<span
						className="is-liked"
						onClick={toggleFavorite}
					>
						<span>{favorite ? <HeartSolid /> : <HeartOutline />}</span>
						{favorite ? 'Sparad' : ''}
					</span>
					<span className="city">
						{car.city}
						<MapPin />
					</span>
				</div>
			</LinkTo>
		</div>
	)
}
export default CarCard


const HeartOutline = () => {
	const style = {
		fill: 'none',
		stroke: '#ccc',
		strokeWidth: 2
	}

	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="25.333" height="22.402" viewBox="0 0 25.333 22.402">
			<g id="Icon:_Heart" data-name="Icon: Heart" transform="translate(1 1)">
				<path id="heart" d="M23.083,4.766a6.216,6.216,0,0,0-8.685,0L13.215,5.929,12.032,4.766a6.217,6.217,0,0,0-8.685,0,5.961,5.961,0,0,0,0,8.535l1.183,1.163L13.215,23,21.9,14.464,23.083,13.3a5.96,5.96,0,0,0,0-8.535Z" transform="translate(-1.549 -2.998)" style={style} />
			</g>
		</svg>
	)
}

const HeartSolid = () => {

	const style = {
		fill: '#c8372f'
	}

	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="23.333" height="20" viewBox="0 0 23.333 20">
			<path id="heart" d="M23.083,4.766a6.216,6.216,0,0,0-8.685,0L13.215,5.929,12.032,4.766a6.217,6.217,0,0,0-8.685,0,5.961,5.961,0,0,0,0,8.535l1.183,1.163L13.215,23,21.9,14.464,23.083,13.3a5.96,5.96,0,0,0,0-8.535Z" transform="translate(-1.549 -2.998)" style={style} />
		</svg>
	)
}

const MapPin = () => {

	const pathStyle = {
		fill: 'none',
		stroke: '#1a171b',
		strokeLinecap: 'round',
		strokeLinejoin: 'round',
		strokeWidth: 2
	}

	const circleStyle = {
		fill: 'none',
		stroke: '#1a171b',
		strokeLinecap: 'round',
		strokeLinejoin: 'round',
		strokeWidth: 2
	}

	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="18.364" height="22" viewBox="0 0 18.364 22">
			<g id="Icon:_Location" data-name="Icon: Location" transform="translate(1 1)">
				<path id="Path_226" data-name="Path 226" d="M19.364,9.182C19.364,15.545,11.182,21,11.182,21S3,15.545,3,9.182a8.182,8.182,0,1,1,16.364,0Z" transform="translate(-3 -1)" style={pathStyle} />
				<circle id="Ellipse_16" data-name="Ellipse 16" cx="2.727" cy="2.727" r="2.727" transform="translate(5.454 5.454)" style={circleStyle} />
			</g>
		</svg>
	)
}